import Vue from 'vue'
import VueRouter from 'vue-router'
import Presentation from '../views/Presentation'
import Experience from '../views/Experience'
import Formation from '../views/Formation'
import Knowledge from '../views/Knowledge'
import Contact from '../views/Contact'

Vue.use(VueRouter)

const routes = [
  { path: '*', redirect: '/presentation' },
  { path: '/presentation', name: 'Presentation', component: Presentation },
  { path: '/experience', name: 'Experience', component: Experience },
  { path: '/formation', name: 'Formation', component: Formation },
  { path: '/knowledge', name: 'Knowledge', component: Knowledge },
  { path: '/contact', name: 'Contact', component: Contact },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
